<template>
  <div class="hm-card landing blue-header-banner">
    <div class="header-banner">
      <h2>About Your Bank and Investment Accounts</h2>
      <p>Include money from accounts such as checking, savings, stocks, and bonds that you and/or your spouse
        have.</p>
    </div>
    <div class="max-w">
      <div class="large-icons-block">
        <SuiButton basic color="grey" class="large-icon-square" @click="onClickMoreThan">
          <span>I Have $14,610 or More / <br/> We Have $28,720 or More</span>
          <div class="img circle-check"></div>
        </SuiButton>
        <SuiButton basic color="grey" class="large-icon-square" @click="onClickLessThan">
          <span>I Have Less Than $14,610 / <br/> We Have Less Than $28,720</span>
          <div class="img circle-times"></div>
        </SuiButton>
      </div>
    </div>
  </div>
</template>

<script>
  import BankAndInvestment from '@/components/small/BankAndInvestment';

  export default {
    extends: BankAndInvestment,
  }
</script>

<style lang="scss" scoped>

  .large-icon-square:hover {
    .circle-check {
      background-image: url('//hm-lis.herokuapp.com/img/svg/Above_green.svg');
    }
    .circle-times {
      background-image: url('//hm-lis.herokuapp.com/img/svg/Below_green.svg');
    }
  }
  .circle-check {
    background-image: url('//hm-lis.herokuapp.com/img/svg/Above.svg');
  }
  .circle-times {
    background-image: url('//hm-lis.herokuapp.com/img/svg/Below.svg');
  }

</style>
